"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ClientEntityContext {
    constructor(animationManager, region, currentPlayerUsername) {
        this.animationManager = animationManager;
        this.region = region;
        this.currentPlayerUsername = currentPlayerUsername;
    }
}
exports.default = ClientEntityContext;
//# sourceMappingURL=ClientEntityContext.js.map